import request from '@/utils/request'

// 查询待领取道具
export function getPendingGrant(userId) {
  return request({
    url: '/v1/propGrant/pending',
    method: 'get',
    params: { userId }
  })
}

// 领取道具
export function receiveGrant(userId, grantId) {
  return request({
    url: '/v1/propGrant/receive',
    method: 'post',
    params: { userId, grantId }
  })
}

// 使用积分卡
export function usePointsCard(userId, propId, num = 1) {
  return request({
    url: '/v1/propGrant/usePointsCard',
    method: 'post',
    params: { userId, propId, num }
  })
}

// 获取用户优惠券（type=3）
export function getUserCouponList(userId) {
  return request({
    url: '/v1/propGrant/couponList',
    method: 'get',
    params: { userId, propId: 3, pageNo: 1, pageSize: 1 }
  })
}

// 查询用户VIP体验卡数量
export function getUserTrialCardNum(userId) {
  return request({
    url: '/v1/propGrant/trialCardNum',
    method: 'get',
    params: { userId }
  })
}
// 使用VIP体验卡开通会员
export function useVipTrialCard(userId) {
  return request({
    url: '/v1/propGrant/useTrialCard',
    method: 'post',
    params: { userId }
  })
}
// 查询用户置顶卡数量
export function getUserTopCardNum(userId) {
  return request({
    url: '/v1/propGrant/topCardNum',
    method: 'get',
    params: { userId }
  })
}
// 使用置顶卡
export function useTopCard(userId, articleId) {
  return request({
    url: '/v1/propGrant/useTopCard',
    method: 'post',
    params: { userId, articleId }
  })
}

// 查询用户推荐卡数量
export function getUserRecommendCardNum(userId) {
  return request({
    url: '/v1/propGrant/recommendCardNum',
    method: 'get',
    params: { userId }
  })
}
// 使用推荐卡推荐文章
export function useRecommendCard(userId, articleId) {
  return request({
    url: '/v1/propGrant/useRecommendCard',
    method: 'post',
    params: { userId, articleId }
  })
}
